//import LinkOption from "./LinkService.vue";
import Ncf from "./NcfLinkService.vue";
import mpago from "./MagypagoLinkService.vue";
import fide from "./FidelizacionLinkService.vue";
import CustomerLink from "./CustomerLink.vue";
import TerminalLink from "./TerminalesLink.vue";
import CustomerACT from "./CustomerACT.vue";
import CustomerINA from "./CustomerINA.vue";

export const Columns = [
  {
    prop: "Rnc",
    label: "Rnc",
    minWidth: 70,
    sortable: true,
    fixed: true
  },
  {
    prop: "Name",
    label: "Nombre",
    minWidth: 120,
    sortable: true,
    fixed: true
  },
  {
    prop: "NcfMovilQty",
    label: "NcfMovil",
    minWidth: 80,
    sortable: true,
    fixed: true,
    formatter: Ncf
  },
  {
    prop: "MagyPagoQty",
    label: "Magypago",
    minWidth: 80,
    sortable: true,
    fixed: true,
    formatter: mpago
  },
  {
    prop: "FidelizacionQty",
    label: "Fidelizacion",
    minWidth: 80,
    sortable: true,
    fixed: true,
    formatter: fide
  },
  {
    prop: "CustomerQty",
    label: "Clientes",
    minWidth: 80,
    sortable: true,
    fixed: true,
    formatter: CustomerLink
  },
  {
    prop: "CustomerQty_ACT",
    label: "Clientes Activos",
    minWidth: 80,
    sortable: true,
    fixed: true,
    formatter: CustomerACT
  },
  {
    prop: "CustomerQty_INA",
    label: "Clientes Inactivos",
    minWidth: 80,
    sortable: true,
    fixed: true,
    formatter: CustomerINA
  },
  {
    prop: "TerminalQty",
    label: "Terminales",
    minWidth: 80,
    sortable: true,
    fixed: true,
    formatter: TerminalLink
  }
];

export const ColumnsServices = [
  { prop: "Rnc", label: "Rnc", minWidth: 95, sortable: true, fixed: true },
  {
    prop: "Nombre",
    label: "Nombre",
    minWidth: 150,
    sortable: true,
    fixed: true
  },
  {
    prop: "Status",
    label: "Estatus",
    minWidth: 60,
    sortable: true,
    fixed: true
  },
  {
    prop: "Direccion1",
    label: "Direccion 1",
    minWidth: 150,
    sortable: true,
    fixed: true
  },
  {
    prop: "Direccion2",
    label: "Direccion 2",
    minWidth: 150,
    sortable: true,
    fixed: true
  },
  {
    prop: "Direccion3",
    label: "Direccion 3",
    minWidth: 150,
    sortable: true,
    fixed: true
  },

  {
    prop: "Serie_Walk",
    label: "Serie Walk",
    minWidth: 80,
    sortable: true,
    fixed: true
  },
  {
    prop: "Serie_Terminal",
    label: "Serie Terminal",
    minWidth: 80,
    sortable: true,
    fixed: true
  },
  {
    prop: "Precio",
    label: "Precio",
    minWidth: 80,
    sortable: true,
    fixed: true
  },
  { prop: "Tasa", label: "Tasa", minWidth: 80, sortable: true, fixed: true }
];

export const ColumnsCustomer = [
  {
    prop: "Rnc",
    label: "Rnc",
    minWidth: 100,
    sortable: true,
    fixed: true
  },
  {
    prop: "Nombre",
    label: "Nombre",
    minWidth: 150,
    sortable: true,
    fixed: true
  },

  {
    prop: "Status",
    label: "Estado",
    minWidth: 80,
    sortable: true,
    fixed: true
  },
  {
    prop: "Correo",
    label: "Correo",
    minWidth: 80,
    sortable: true,
    fixed: true
  },
  {
    prop: "Direccion1",
    label: "Direccion 1",
    minWidth: 180,
    sortable: true,
    fixed: true
  },
  {
    prop: "Direccion2",
    label: "Direccion 2",
    minWidth: 180,
    sortable: true,
    fixed: true
  },
  {
    prop: "Direccion3",
    label: "Direccion 3",
    minWidth: 180,
    sortable: true,
    fixed: true
  },
  {
    prop: "Tarjetas",
    label: "Tarjetas",
    minWidth: 80,
    sortable: true,
    fixed: true
  }
];

export const ColumnsTerminales = [
  {
    prop: "rnc",
    label: "Sucursal",
    minWidth: 50,
    sortable: true,
    fixed: true
  },
  {
    prop: "nombre",
    label: "Nombre",
    minWidth: 50,
    sortable: true,
    fixed: true
  },
  {
    prop: "terminal",
    label: "terminal",
    minWidth: 50,
    sortable: true,
    fixed: true
  },
  {
    prop: "Serie_Terminal",
    label: "Serie Terminal",
    minWidth: 50,
    sortable: true,
    fixed: true
  },
  {
    prop: "Serie_Walk",
    label: "Serie Walk",
    minWidth: 50,
    sortable: true,
    fixed: true
  },
  {
    prop: "Modelo",
    label: "Modelo",
    minWidth: 50,
    sortable: true,
    fixed: true
  },
  {
    prop: "Status",
    label: "Estado",
    minWidth: 50,
    sortable: true,
    fixed: true
  },
  {
    prop: "direccion1",
    label: "Direccion 1",
    minWidth: 150,
    sortable: true,
    fixed: true
  },
  {
    prop: "direccion2",
    label: "Direccion 2",
    minWidth: 150,
    sortable: true,
    fixed: true
  },
  {
    prop: "direccion3",
    label: "Direccion 3",
    minWidth: 150,
    sortable: true,
    fixed: true
  }
];
